



























import {
  defineComponent, reactive, toRefs,
} from '@vue/composition-api'
import Pod from '@/components/layouts/Pod.vue'

type State = {
  test: boolean;
}

const initialState: State = { test: false }

export default defineComponent({
  components: {
    Pod,
  },
  props: {
    newClients: { type: Array, default: () => ([]) },
  },

  setup(props, context) {
    const state = reactive({ ...initialState })

    const openClientPage = (clientId: string) => {
      context.root.$router.push({ name: 'journal', params: { clientId } })
    }

    const dismiss = (index: number) => context.emit('dismissed', index)

    return { ...toRefs(state), dismiss, openClientPage }
  },
})

